import { REFERENCE_IMAGE_FILE_CONTAINER } from '@/modules/api/constant';
import { logger } from '@common/logging/logger';


// obsolete?
export const referenceImageFileNameUtils = {
  getDisplayNameFromPersistedFileRef: (fileRef: string): string => {
    const fileNameWithExtension = fileRef.split(`${REFERENCE_IMAGE_FILE_CONTAINER}/`).at(1);

    if (!fileNameWithExtension) {
      logger.error(
        `Could not derive a display name from provided fileRef. Defaulted to the provided name.`,
      );

      return fileRef;
    }

    const fileNameWithoutExtension = fileNameWithExtension.split('.').at(0);

    return fileNameWithoutExtension || fileNameWithExtension;
  },
  getFilenameWithExtension: (fileRef: string): string => {
    const fileNameWithExtension = fileRef.split(`${REFERENCE_IMAGE_FILE_CONTAINER}/`).at(1);

    if (!fileNameWithExtension) {
      logger.error(
        `Could not derive a display name from provided fileRef. Defaulted to the provided name.`,
      );

      return fileRef;
    }

    return fileNameWithExtension;
  },
} as const;
